export default __webpack_public_path__ + "static/SRUS P170 - Product Specifications & Technical Data-f22b8ade0d7833de4a5ddcd05609b94e.pdf";